module.exports = __webpack_public_path__ + "img/APPSTORE.72c7e0cf.png";